import React, { Fragment, useEffect, useRef, useState, useContext } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { FormGroup, Input, Label } from "reactstrap";
import { Button, DescriptionList, Field, Loader } from "../../../../../ui";
import { Dialog } from "../ui-pending";
import "./style.scss";
import { calendarData, demoStudentClassCalendar, fetchCalendar, getStudentDemoCompleteStatus, insertSlot, leaveDetails } from "../../../../../Api/apiUtils";
import ScheduledModal from "./ ScheduledModal";
import DemoSlotModal from "./DemoRescheduleModal";
import { ConfigContext } from "../../../../../Api/global/ApiContext";
import { constrainPoint } from "@fullcalendar/core/internal";
import { constant } from "../../../../../Api/mixpanel";
import { toast } from 'react-toastify';
import { MixpanelEvents, trackEvent } from "../../../../../utils/mixpanelTracking";
import { isTeacherLeaderDisabled } from "../../../../../utils/permissions";


interface CalendarEvent {
  id: string;
  title?: string;
  start: string;
  end: string;
  color: string;
  extendedProps: Record<string, unknown>;
}

interface calendarProps {
  courseId: any;
  courseExpiry:any;
  selectedTeacherName:any;
  courseData:any
  /** Full student courses from /admin/courses (match parentTagId → option.id for demo disable). */
  studentCourses?: any[];
  selectedCourseData:any;
  studentId:any;
  credentialId?: any;
  profileData:any;
  courseCounts: {
    unscheduledClasses: number;
    completedClasses: number;
    scheduledClasses: number;

  };
  fetchCourses: () => Promise<void>;
}


const eventStatuses = [

  { label: "Scheduled", color: "#f5c542" },
  { label: "Completed", color: "grey" },
  { label: "Rescheduled", color: "lightblue" },
  { label: "Deleted - Cancelled", color: "#9ca3af" },
  { label: "Free", color: "#bed197" },
  { label: "Special-Free", color: "palevioletred" },
  { label: "Leave", color: "#f54242" },
];

const getDateRange = (view: string, startDate: Date) => {
  let fromDate = "";
  let toDate = "";

  if (view === "dayGridMonth") {
    const year = startDate.getFullYear();
    const month = startDate.getMonth();
    fromDate = new Date(year, month, 1).toISOString().split("T")[0];
    toDate = new Date(year, month + 1, 0).toISOString().split("T")[0];
  } else if (view === "timeGridWeek") {
    const weekStart = new Date(startDate);
    weekStart.setDate(startDate.getDate() - startDate.getDay());
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);

    fromDate = weekStart.toISOString().split("T")[0];
    toDate = weekEnd.toISOString().split("T")[0];
  } else if (view === "timeGridDay") {
    fromDate = startDate.toISOString().split("T")[0];
    toDate = startDate.toISOString().split("T")[0];
  }

  return { fromDate, toDate };
};

/** Ensure times like "6:00:00" / "06:00" become valid ISO time fragments. */
const normalizeTimeForCalendar = (time: unknown): string => {
  const raw = String(time ?? "").trim();
  if (!raw) return "00:00:00";
  const parts = raw.split(":");
  const hh = String(parts[0] ?? "0").padStart(2, "0");
  const mm = String(parts[1] ?? "0").padStart(2, "0");
  const ss = String(parts[2] ?? "0").padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
};

const DragCalendar : React.FC<calendarProps> =({ selectedCourseData, courseExpiry, courseData, studentCourses, courseCounts, fetchCourses, courseId, selectedTeacherName, profileData, studentId, credentialId}) => {
  console.log("courseData", courseData);
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const [loading, setLoading] = useState(false);
  const readOnly = isTeacherLeaderDisabled();
  const [demoStatusDetails, setDemoStatusDetails] = useState<any>(null);
  const [showBookDemoModal, setShowBookDemoModal] = useState(false);
  // const mixpanel = require(co'mixpanel-browser');
  const [dateRange, setDateRange] = useState(() => {
    const today = new Date();
    return getDateRange("dayGridMonth", today);
  });
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [basicTooltip, setBasicTooltip] = useState(false);
  const toggle = () => setBasicTooltip(!basicTooltip);
  const [modalOpen, setModalOpen] = useState(false);
  const [rescheduleData, setRescheduleData] = useState<any>(null);
  const [isSchedulingMode, setIsSchedulingMode] = useState(false);
  const [triggeredByScheduledButton, setTriggeredByScheduledButton] = useState<boolean>(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [storedStudentId, setStoredStudentId] = useState<string>("");
  const [storedClassId, setStoredClassId] = useState<string>("");
  const [calendarRef, setCalendarRef] = useState<any>(null);
  const [actionSource, setActionSource] = useState<"schedule" | "reschedule" | null>(null)
    const [selectedSlot, setSelectedSlot] = useState({
      startTime: "",
      endTime: "",
      slotDate: "",
      specialSlot: false,
    });
  const [currentActionMode, setCurrentActionMode] = useState<"schedule" | "reschedule" | null>(null);
  // Trial courses usually hold one or two classes that can be years old, so the calendar
  // jumps to them and a strip above it lists them instead of paging back month by month
  const [isTrialCourse, setIsTrialCourse] = useState(false);
  const jumpedForCourseRef = useRef<string | null>(null);
  const [selectedTrialClassId, setSelectedTrialClassId] = useState("");

  const config = useContext(ConfigContext);

    useEffect(() => {
      const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === "Enter" && isConfirmModalOpen) {
          handleConfirmSlot();
        }
      };
    
      if (isConfirmModalOpen) {
        window.addEventListener("keydown", handleKeyDown);
      }
    
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [isConfirmModalOpen]);

  useEffect(() => {
    fetchCalendarData();
  }, [courseId, profileData?.userId, courseData]);

  const refreshDemoEligibility = async () => {
    if (!studentId) {
      setDemoStatusDetails(null);
      return;
    }
    try {
      const response = await getStudentDemoCompleteStatus(studentId);
      setDemoStatusDetails(response);
    } catch (error) {
      console.error("Error fetching demo eligibility:", error);
      setDemoStatusDetails(null);
    }
  };

  useEffect(() => {
    void refreshDemoEligibility();
  }, [studentId]);

  const fetchCalendarData = async () => {
    setIsSchedulingMode(false);
    setCurrentActionMode(null);
    setLoading(true);
    const selectedCourse = courseId;
    // Use current profile's userId first so the calendar always shows this student's data.
    // Fallback to localStorage for reschedule/schedule flows that set it.
    const studentUserId =
      profileData?.userId ??
      profileData?.id ??
      JSON.parse(localStorage.getItem("studentUserId") || "null");

    if (!selectedCourse || !studentUserId) {
      setLoading(false);
      return;
    }

    // Keep localStorage in sync so Schedule Class / Reschedule use the same student
    try {
      localStorage.setItem("studentUserId", String(studentUserId));
    } catch (_) {}

    try {
      const selectedCourseMeta = Array.isArray(courseData)
        ? courseData.find((course: any) => {
            const currentCourseId =
              course?.courseId ?? course?.id ?? course?.v2Id ?? course?.studentCourseId;
            return String(currentCourseId) === String(selectedCourse);
          })
        : courseData;
      const profileCourseMeta = Array.isArray(profileData?.courses)
        ? profileData.courses.find((course: any) => {
            const currentCourseId =
              course?.courseId ?? course?.id ?? course?.v2Id ?? course?.studentCourseId;
            return String(currentCourseId) === String(selectedCourse);
          })
        : null;
      const isDemoCourse = Boolean(selectedCourseMeta?.isDemoCourse ?? profileCourseMeta?.isDemoCourse);
      setIsTrialCourse(isDemoCourse);
      const response = isDemoCourse
        ? await demoStudentClassCalendar(studentId, selectedCourse, 0, 100)
        : await calendarData(studentUserId, selectedCourse);

      // Normalize: API may return a direct array or an object with data/content/classes
      const rawList = Array.isArray(response)
        ? response
        : (response?.data ?? response?.content ?? response?.classes ?? response?.result ?? []);

      if (!Array.isArray(rawList) || rawList.length === 0) {
        setEvents([]);
        return;
      }

      const formattedEvents = rawList
        .filter((event: any) => {
          const slotDate = event?.slotDate ?? event?.classDate ?? event?.date;
          const startTime = event?.startTime ?? event?.classStartTime ?? event?.start_time;
          const endTime = event?.endTime ?? event?.classEndTime ?? event?.end_time;
          // API may return classId and/or classScheduleId depending on endpoint/version
          const idValue =
            event?.classScheduleId ?? event?.classId ?? event?.id ?? event?.studentSlotId;
          return event && idValue != null && String(idValue).trim() !== "" && slotDate && startTime != null && endTime != null;
        })
        .filter((event: any) => {
          const status = normalizeClassStatus(event);
          if (status === "NOTCONDUCTED") return false;
          // Paid calendar: hide cancelled / deleted classes from the grid
          if (!isDemoCourse && (status === "CANCELLED" || status === "DELETED")) {
            return false;
          }
          return true;
        })
        .map((event: any) => {
          const normalizedStatus = normalizeClassStatus(event);
          const statusColor = getStatusColor(normalizedStatus);
          const idValue =
            event?.classScheduleId ?? event?.classId ?? event?.id ?? event?.studentSlotId;
          const slotDate = String(event.slotDate ?? event.classDate ?? event.date).trim();
          const startTime = normalizeTimeForCalendar(event.startTime ?? event.classStartTime ?? event.start_time);
          const endTime = normalizeTimeForCalendar(event.endTime ?? event.classEndTime ?? event.end_time);
          return {
            id: String(idValue),
            title: getStatusDisplayTitle(normalizedStatus),
            start: `${slotDate}T${startTime}`,
            end: `${slotDate}T${endTime}`,
            color: statusColor,
            backgroundColor: statusColor,
            borderColor: statusColor,
            extendedProps: {
              ...event,
              classStatus: normalizedStatus,
              classScheduleId: event?.classScheduleId ?? event?.classId ?? idValue,
              classId: event?.classId ?? event?.classScheduleId ?? idValue,
            },
          };
        });

      setEvents(formattedEvents);
    } catch (error) {
      console.error("Error fetching calendar data:", error);
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };
  type StatusType =
  | "SCHEDULED"
  | "DEDUCTED_RESCHEDULE"
  | "CANCELLED"
  | "COMPLETED"
  | "DEDUCTED_CANCEL"
  | "RESCHEDULED"
  | "DELETED"
  | "NOTCONDUCTED";


const getStatusColor = (status: StatusType): string => {
  const colors = {
    SCHEDULED: "#f5c542",
    DEDUCTED_RESCHEDULE: "#f59e0b",
    CANCELLED: "red",
    COMPLETED: "grey",
    DEDUCTED_CANCEL: "#f97316",
    RESCHEDULED: "lightblue",
    DELETED: "#9ca3af",
    NOTCONDUCTED: "#a855f7",
    DEFAULT: "#6fc2ae",
  };

  return colors[status] || colors.DEFAULT;
};

const getStatusDisplayTitle = (status: StatusType): string => {
  if (status === "DELETED") return "Cancelled";
  if (status === "NOTCONDUCTED") return "Not Conducted";
  return status;
};

const normalizeClassStatus = (event: any): StatusType => {
  const rawStatus =
    event?.classStatus ??
    event?.slotStatus ??
    event?.classBookingStatus ??
    event?.status ??
    "";

  const normalized = String(rawStatus).trim().toUpperCase().replace(/[\s_-]+/g, "");
  if (normalized.includes("DELET")) return "DELETED";
  if (normalized.includes("DEDUCTEDRESCHEDULE")) return "DEDUCTED_RESCHEDULE";
  if (normalized.includes("DEDUCTEDCANCEL")) return "DEDUCTED_CANCEL";
  if (normalized.includes("NOTCONDUCT")) return "NOTCONDUCTED";
  if (normalized.includes("RESCHEDULE")) return "RESCHEDULED";
  if (normalized.includes("SCHEDULE")) return "SCHEDULED";
  if (normalized.includes("COMPLET")) return "COMPLETED";
  if (normalized.includes("CANCEL")) return "CANCELLED";
  return "SCHEDULED";
};
  const handleMoreLinkClick = (date:any) => {
    if (calendarRef) {
      calendarRef.getApi().changeView("timeGridDay", date);
    }
  };
  const handleDatesSet = (dateInfo: any) => {
    const fromDate = dateInfo.start.toISOString().split("T")[0];
    const toDate = dateInfo.end.toISOString().split("T")[0];
    setDateRange({ fromDate, toDate });

    // Leaving the picked trial class's dates (e.g. "today") clears the dropdown,
    // so choosing that class again fires onChange and jumps back to it
    setSelectedTrialClassId((currentId) => {
      const selected = trialClasses.find((event) => event.id === currentId);
      if (!selected) return currentId;
      const classTime = new Date(selected.start).getTime();
      const inView = classTime >= dateInfo.start.getTime() && classTime < dateInfo.end.getTime();
      return inView ? currentId : "";
    });

    if (isSchedulingMode && currentActionMode) {
      handleReschedule("", currentActionMode, { fromDate, toDate });
    }
  };

  const handleConfirmSlot = async () => {
    // const selectedCourseTeacherId = localStorage.getItem("SelectedCourseTeacherId");
    const payload = [
      {
        teacherId: selectedCourseData,
        startTime: selectedSlot.startTime,
        EndTime: selectedSlot.endTime,
        slotDate: selectedSlot.slotDate,
        specialSlot: selectedSlot.specialSlot,
      },
    ];
  
    try {
      await insertSlot(payload);
      toast.success("Slot created successfully!");
      trackEvent(MixpanelEvents.CALENDAR_SLOT_INSERTED, {
        calendarView: "student",
        studentId: studentId != null ? String(studentId) : undefined,
        profileUserId: profileData?.userId != null ? String(profileData.userId) : undefined,
        courseId: courseId != null ? String(courseId) : undefined,
        teacherSlotTeacherId: selectedCourseData != null ? String(selectedCourseData) : undefined,
        slotDate: selectedSlot.slotDate,
        specialSlot: selectedSlot.specialSlot,
      });
      setIsConfirmModalOpen(false);
      handleReschedule("","schedule", dateRange);
    } catch (error: any) {
      console.error("Error inserting slot:", error);
      trackEvent(MixpanelEvents.CALENDAR_SLOT_INSERT_FAILED, {
        calendarView: "student",
        studentId: studentId != null ? String(studentId) : undefined,
      });
      
      // Check if this is a slot already exists error
      if (error.response?.status === 400 && 
          error.response?.data?.["TeacherSlot already exist!"] === true) {
        toast.error("This slot already exists for the teacher!");
      } else {
        toast.error("Failed to create slot. Please try again.");
      }
    }
  };

const handleSelect = (selectInfo: any) => {
  if (!isSchedulingMode) {
    toast.error("Please click 'Schedule Class' first to select available slots");
    selectInfo.view.calendar.unselect();
    return;
  }
  const timeDisplay = document.createElement('div');
  timeDisplay.className = 'time-selection-feedback';
  document.body.appendChild(timeDisplay);

  // Function to update time display
  const updateTimeDisplay = () => {
    const startDate = new Date(selectInfo.startStr);
    const endDate = new Date(selectInfo.endStr);
    
    const formatTime = (date: Date) => {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };
    
    const durationMinutes = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60));
    timeDisplay.textContent = `${formatTime(startDate)} - ${formatTime(endDate)} (${durationMinutes} mins)`;
    
    // Position near cursor
    const mouseEvent = selectInfo.jsEvent;
    timeDisplay.style.left = `${mouseEvent.clientX + 15}px`;
    timeDisplay.style.top = `${mouseEvent.clientY + 15}px`;
  };

  // Track mouse movement
  const handleMouseMove = (e: MouseEvent) => {
    updateTimeDisplay();
  };

  // Clean up when done
  const cleanup = () => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.body.removeChild(timeDisplay);
    document.removeEventListener('mouseup', cleanup);
  };

  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', cleanup);

  // Initial update
  updateTimeDisplay();

  // Your existing validation logic
  const startDate = new Date(selectInfo.startStr);
  const endDate = new Date(selectInfo.endStr);
  const durationMinutes = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60));
  if (durationMinutes % 30 !== 0) {
    toast.error("Please select slots in 30-minute increments (30, 60, 90, etc.)");
    selectInfo.view.calendar.unselect();
    cleanup();
    return;
}

  const currentTime = new Date();
  if (startDate < currentTime) {
    toast.error("You can only select slots after the current time.");
    selectInfo.view.calendar.unselect();
    cleanup();
    return;
  }

  const endTimeStr = endDate.toTimeString().split(' ')[0];
  const adjustedEndTime = endTimeStr === '23:59:59' ? '24:00:00' : endTimeStr;

  setSelectedSlot({
    startTime: startDate.toTimeString().split(' ')[0],
    endTime: adjustedEndTime,
    slotDate: selectInfo.startStr.split('T')[0],
    specialSlot: false,
  });

  setIsConfirmModalOpen(true);
  cleanup();
};

  const handleEventClick = (clickInfo: any) => {
    
    const event = clickInfo.event.extendedProps;
    const isLeaveEvent = clickInfo.event.extendedProps?.isLeave || 
 
    clickInfo.event.title?.includes('Leave') || 
    clickInfo.event.backgroundColor === '#ff5151';
    // const rnr =  clickInfo.event.title?.includes('RnR')
    if (event.studentUserId) {
      setStoredStudentId(event.studentUserId);
    }
    if (event.classScheduleId || event.classId) {
      setStoredClassId(String(event.classScheduleId ?? event.classId));
    }
    if (!isLeaveEvent) {
    setSelectedEvent(event);
    setModalOpen(true);
    }
  };

  
  const handleReschedule = async (classId: string, source: "schedule" | "reschedule", customDateRange?: {fromDate: string, toDate: string}) => {
    setModalOpen(false);
    setLoading(true);
    setActionSource(source);
    setIsSchedulingMode(true);
    setCurrentActionMode(source);
    
    try {
      const storedTeacherId = localStorage.getItem("teacherUserId");
      const storedStudentId = localStorage.getItem("studentUserId");
  
      if (!storedTeacherId || !storedStudentId) {
        console.error("Missing teacherUserId or studentUserId in local storage.");
        return;
      }
  
      const { fromDate, toDate } = customDateRange || dateRange;
      
      console.log("handleReschedule - customDateRange:", customDateRange);
      console.log("handleReschedule - dateRange state:", dateRange);
      console.log("handleReschedule - final dates being used:", { fromDate, toDate });
  
      const payload = {
        fromDate,
        toDate,
        teacherUserId: storedTeacherId,
        studentUserId: storedStudentId,
        actionBy: "student",
        courseId:courseId,
      };
  
      const response = await fetchCalendar(payload);
      setRescheduleData(response);
  
      const dayStats: Record<string, { 
        workingHour: number, 
        bookedSlots: number,
        currentStudentBookedSlots: number 
      }> = {};
  
      response.forEach((event: any) => {
        const date = event.slotDate;
        
        if (!dayStats[date]) {
          // Convert workingHour to number if it's a string
          const workingHour = typeof event.workingHour === 'string' ? parseFloat(event.workingHour) : event.workingHour;
          dayStats[date] = { workingHour, bookedSlots: 0, currentStudentBookedSlots: 0 };
        }
        
        // For booked slots, we count the number of slots, not the duration
        // Since each slot represents a fixed time period (e.g., 1 hour)
        if (event.isBooked) {
          dayStats[date].bookedSlots += 1; // Count each booked slot as 1
          console.log(`Added 1 slot to bookedSlots for ${date}. Total: ${dayStats[date].bookedSlots}`);
        }
        
        // Add to currentStudentBookedSlots if booked by current student
        if (event.isBookedForCurrentStudent) {
          dayStats[date].currentStudentBookedSlots += 1; // Count each slot as 1
        }
      });
  
      setRescheduleData({
        ...response,
        dayStats // Include the calculated day statistics
      });
  
      const mappedEvents = response
      .map((event: any) => {
        // Skip only student's already booked slots
        if (event.isBookedForCurrentStudent && event.isBooked) {
          return null;
        }
    
        let backgroundColor = "#bed197";
        let borderColor = "#bed197";
        let title = event.title || "Free Slot";
    
        // If API gave us a title → force pink color
        if (event.title) {
          backgroundColor = "#e82c86";
          borderColor = "#e82c86";
        }
    
        // Special slots override color but keep API title if available
        if (event.specialSlot === true) {
          backgroundColor = "palevioletred";
          borderColor = "palevioletred";
          title = event.title || "Special Free Slot";
        }
    
        return {
          classStatus: event.classBookingStatus,
          start: `${event.slotDate}T${event.startTime}`,
          end: `${event.slotDate}T${event.endTime}`,
          backgroundColor,
          borderColor,
          title,
          extendedProps: event,
        };
      })
      .filter((event: any) => event !== null);
    
    
  
        const leaveResponse = await leaveDetails(selectedCourseData);
      const approvedLeaves = leaveResponse.content.filter((leave: any) => leave.leaveStatus?.type === 'leave_approved');
      const leaveEvents = approvedLeaves.flatMap((leave: any) => {
        const fromDate = leave.fromDate.split(' ')[0];
        const toDate = leave.toDate.split(' ')[0];
        const start = `${fromDate}T${leave.startTime}`;
        const end = `${toDate}T${leave.endTime}`;
      
        // For all-day event, end should be exclusive, so add 1 day
        const endAllDay = new Date(toDate);
        endAllDay.setDate(endAllDay.getDate() + 1);
        const endAllDayStr = endAllDay.toISOString().split('T')[0];
      
        // 1. Foreground all-day event for month view
        const monthEvent = {
          start: fromDate,
          end: endAllDayStr,
          backgroundColor: '#ff5151',
          borderColor: '#ff5151',
          title: `Leave`,
          allDay: true,
          editable: false,
          display: 'auto', // foreground
        };
      
        // 2. Background event for week/day view
        const backgroundEvent = {
          start,
          end,
          backgroundColor: '#ff5151',
          borderColor: '#ff5151',
          title: 'Leave',
          color: 'red',
          allDay: false,
          editable: false,
          display: 'background',
        };
      
        return [monthEvent, backgroundEvent];
      });



      setEvents([...mappedEvents, ...leaveEvents]);
  
    } catch (error) {
      console.error("Error rescheduling event:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleDateClick = (arg: any) => {
    setIsConfirmModalOpen(false);
    if (calendarRef) {
      calendarRef.getApi().changeView('timeGridDay', arg.date);
    }
  };
  // Trial classes oldest first, for the strip above the calendar
  const trialClasses = isTrialCourse
    ? [...events].sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime())
    : [];

  const goToCalendarDate = (start: string) => {
    if (calendarRef) calendarRef.getApi().gotoDate(start.split("T")[0]);
  };

  // Once per trial course: open on the next upcoming trial class, else the latest past one
  useEffect(() => {
    if (!isTrialCourse || !calendarRef || trialClasses.length === 0) return;
    const courseKey = String(courseId);
    if (jumpedForCourseRef.current === courseKey) return;
    jumpedForCourseRef.current = courseKey;
    const now = Date.now();
    const upcoming = trialClasses.find((event) => new Date(event.start).getTime() >= now);
    const initial = upcoming || trialClasses[trialClasses.length - 1];
    setSelectedTrialClassId(initial.id);
    goToCalendarDate(initial.start);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTrialCourse, calendarRef, events, courseId]);

  const formatTrialClass = (start: string, end: string) => {
    const startDate = new Date(start);
    const date = startDate.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", weekday: "short" });
    const time = (value: Date) => value.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
    return `${date}, ${time(startDate)} - ${time(new Date(end))}`;
  };

  return (
    <Fragment>
      <div className="student-calendar-toolbar">
        <ul className="student-calendar-legend" aria-label="Class status colours">
          {eventStatuses.map((status, index) => (
            <li key={index} className="student-calendar-legend__item">
              {/* Swatch colour is the same per-status data FullCalendar paints events with */}
              <span className="student-calendar-legend__swatch" style={{ backgroundColor: status.color }} aria-hidden />
              <span>{status.label}</span>
            </li>
          ))}
        </ul>
        <span className="student-calendar-note">Times shown in IST</span>
        <div className="student-calendar-actions">
          <Button
            variant="primary"
            size="sm"
            disabled={readOnly || courseCounts.unscheduledClasses === 0}
            title={readOnly ? "Disabled for Teacher Leaders" : undefined}
            onClick={() => {
              if (readOnly) return;
              handleReschedule("", "schedule", dateRange);
              setIsSchedulingMode(true);
            }}
          >
            Schedule Class
          </Button>
          {demoStatusDetails?.isEnrollNewCourseEligible === true && (
            <Button
              variant="accent"
              size="sm"
              disabled={readOnly}
              title={readOnly ? "Disabled for Teacher Leaders" : undefined}
              onClick={() => {
                if (readOnly) return;
                trackEvent(MixpanelEvents.DEMO_BOOK, {
                  action: "opened",
                  classScheduleId:
                    demoStatusDetails?.classScheduleId ||
                    selectedEvent?.classScheduleId ||
                    null,
                  "UTM Source": "admintool",
                });
                setShowBookDemoModal(true);
              }}
            >
              Book a Demo
            </Button>
          )}
          {trialClasses.length > 0 && (
            <Field
              className="student-calendar-trials"
              label={`Trial ${trialClasses.length > 1 ? "classes" : "class"} (${trialClasses.length})`}
            >
              {(ctl) => (
                <select
                  {...ctl}
                  className="ds-select ds-input--sm"
                  value={trialClasses.some((event) => event.id === selectedTrialClassId) ? selectedTrialClassId : ""}
                  title="Show the selected class in the calendar"
                  onChange={(e) => {
                    const selected = trialClasses.find((event) => event.id === e.target.value);
                    setSelectedTrialClassId(e.target.value);
                    if (selected) goToCalendarDate(selected.start);
                  }}
                >
                  <option value="" disabled>
                    Select a trial class
                  </option>
                  {trialClasses.map((event) => (
                    <option key={event.id} value={event.id}>
                      {formatTrialClass(event.start, event.end)} · {event.title}
                    </option>
                  ))}
                </select>
              )}
            </Field>
          )}
          {isSchedulingMode && (
            <span className="student-calendar-teacher ds-text-muted">
              {selectedTeacherName} (Teacher Calendar)
            </span>
          )}
        </div>
      </div>

      <Dialog
        isOpen={isConfirmModalOpen}
        onClose={() => setIsConfirmModalOpen(false)}
        title="Confirm Selected Slot"
        size="sm"
        actions={
          <Button variant="primary" onClick={handleConfirmSlot}>
            Confirm
          </Button>
        }
      >
        <DescriptionList
          items={[
            { label: "Date", value: selectedSlot.slotDate },
            { label: "Time range", value: `${selectedSlot.startTime} - ${selectedSlot.endTime}` },
          ]}
        />
        <FormGroup check className="mb-0">
          <Label check>
            <Input
              type="checkbox"
              checked={selectedSlot.specialSlot}
              onChange={(e) => setSelectedSlot({ ...selectedSlot, specialSlot: e.target.checked })}
            />{" "}
            Special Slot
          </Label>
        </FormGroup>
      </Dialog>

      <div className="student-calendar-surface">
        {loading && (
          <div className="student-calendar-surface__loading">
            <Loader label="Loading calendar…" />
          </div>
        )}
  <FullCalendar
  ref={setCalendarRef}
  initialView="dayGridMonth"
  initialDate={new Date()}
  headerToolbar={{
    left: "prev,next today",
    center: "title",
    right: "dayGridMonth,timeGridWeek,timeGridDay",
  }}
  views={{
    timeGridWeek: {
      dayHeaderFormat: { weekday: "short",  day: "numeric" }, 
    },
  }}


  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
  events={events}
  editable={true}
  selectable={true}
  droppable={true}
  datesSet={handleDatesSet} 
  eventClick={handleEventClick}
  dateClick={handleDateClick}
  select={handleSelect}

  contentHeight={600} // Allows scrolling within the timing section
  allDaySlot={false} // Ensures all-day events appear separately
  dayMaxEventRows={2} 
  moreLinkClick={(info) => handleMoreLinkClick(info.date)}
  slotDuration="00:15:00" 

  slotLabelInterval="00:30" 
  height="auto"


  eventContent={(arg) => {
    const currentView = arg.view.type; 
    const startTime = arg.event.start?.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    const endTime = arg.event.end?.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return (
      <div
        className="student-calendar-event"
        // Per-event status colour from getStatusColor / slot mapping (FullCalendar data)
        style={{ backgroundColor: arg.event.backgroundColor || arg.event.borderColor || "#f5c542" }}
      >
        {(currentView === "timeGridDay" || currentView === "timeGridWeek") && (
          <div>
            {startTime} - {endTime}
          </div>
        )}
        <div>{arg.event.title}</div>
      </div>
    );
  }}
  />
      </div>
      <ScheduledModal
      fetchCourses={fetchCourses}
      courseExpiry={courseExpiry}
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        eventDetails={selectedEvent || rescheduleData}
        rescheduleEvent={rescheduleData}
        fetchRescheduleData={handleReschedule} // Pass the updated function
        onReschedule={fetchCalendarData}
        actionSource={actionSource} // Pass the action source
        triggeredByScheduledButton={triggeredByScheduledButton}
        storedClassId={storedClassId}
        studentId={studentId}
        profileData={profileData}
        courseTeacherId={selectedCourseData || courseData?.teacherId}
    
      />
      <DemoSlotModal
        mode="book"
        studentId={studentId}
        isOpen={showBookDemoModal}
        toggle={() => setShowBookDemoModal(false)}
        profileData={{
          ...profileData,
          studentCredential:
            profileData?.studentCredential ||
            profileData?.credentialId ||
            credentialId,
        }}
        courses={config?.courses || []}
        studentCourses={Array.isArray(studentCourses) ? studentCourses : []}
        classScheduleId={
          demoStatusDetails?.classScheduleId || selectedEvent?.classScheduleId
        }
        eventDetails={selectedEvent}
        onSuccess={async () => {
          setShowBookDemoModal(false);
          await refreshDemoEligibility();
          await fetchCalendarData();
          await fetchCourses();
        }}
      />
    </Fragment>
  );
};

export default DragCalendar;
